import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { EmbeddedPasswordrequestPage } from './embedded-passwordrequest.page';

const routes: Routes = [
  {
    path: '',
    component: EmbeddedPasswordrequestPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EmbeddedPasswordrequestPageRoutingModule {}
